import _ from "lodash";
import { ProjectContentItem } from "@/models/project";

export default {
  setContent(
    state: any,
    payload: {
      type: string;
      contents: Array<ProjectContentItem>;
    }
  ) {
    if (!state[payload.type].length) {
      state[payload.type] = payload.contents;
    } else {
      _.forEach(payload.contents, (_content) => {
        state[payload.type].push(_content);
      });
    }
  },
  clearState(state: any) {
    _.forEach(Object.keys(state), (key: string) => {
      state[key] = [];
    });
  },
  resetPage(state: any, type: string) {
    state[type.toLowerCase()] = [];
  },
  setSearching(
    state: any,
    payload: {
      type: string;
      contents: Array<ProjectContentItem>;
      total: number;
      search: string;
    }
  ) {
    if (state["searching"][payload.type].values.length) {
      state["searching"][payload.type].values = state["searching"][
        payload.type
      ].values.concat(payload.contents);
    } else {
      state["searching"][payload.type].values = payload.contents;
    }

    state["searching"].search = payload.search;
    state["searching"][payload.type].total = payload.total;
  },
  cleanSearching(state: any, payload: { type: string }) {
    if (state["searching"][payload.type] !== undefined) {
      state["searching"][payload.type].values = [];
      state["searching"][payload.type].total = 0;
    }
  },
  removeContent(
    state: any,
    payload: {
      type: string;
      contentId: string;
    }
  ) {
    if (state[payload.type].length) {
      state[payload.type] = state[payload.type].filter(
        (content: ProjectContentItem) => content.id !== payload.contentId
      );
    }
  },
  addContent(
    state: any,
    payload: {
      type: string;
      content: ProjectContentItem;
    }
  ) {
    if (state[payload.type].length) {
      state[payload.type].push(payload.content);
    }
  },
  updateContent(
    state: any,
    payload: {
      type: string;
      content: ProjectContentItem;
    }
  ) {
    if (!state[payload.type]) {
      return;
    }
    if (!state[payload.type].length) {
      return;
    } else {
      const contentIndex = state[payload.type].findIndex(
        (content: ProjectContentItem) => content.id == payload.content.id
      );
      if (contentIndex !== -1) {
        state[payload.type][contentIndex] = payload.content;
      }
    }
  },
};
